module.exports = __webpack_public_path__ + "img/framework.1eafdf90.png";